import _ from 'underscore';
import {
    FirstPaymentDefinition, ApiHotelOffer,
} from '@ve/types';
import matchFirstPaymentDefinitionsByIds
    from '@/js/common/Domain/Service/searchTour/service/apiTourToTourAdapter/matchFirstPaymentDefinitionsByIds';
import { HotelOffer } from '@ve/types/api/HotelOffer';

export default ({
                    hotelOffers, firstPaymentDefinitions,
                }: {
    hotelOffers: ApiHotelOffer[],
    firstPaymentDefinitions: FirstPaymentDefinition[]
}): HotelOffer[] => {
        const firstPaymentDefinitionsKeys = _.indexBy(firstPaymentDefinitions, 'id');

    return _.map(hotelOffers, (hotelOffer) => ({
        ...hotelOffer,
        firstPaymentDefinitions: matchFirstPaymentDefinitionsByIds({
            firstPaymentDefinitionIds: hotelOffer.firstPaymentDefinitions,
            firstPaymentDefinitionReferenceIndex: firstPaymentDefinitionsKeys,
        }),
    }));
};
